/* Function */
function switchCollection(elem) {
  if(!elem.hasClass('active')) {

    var tab = elem.attr('aria-controls');
    $('.switchCollection').removeClass('active');
    $('[aria-controls="' + tab + '"]').addClass('active');

    var url = new URL(window.location.href);
    url.searchParams.set('tab', tab);
    window.history.pushState({}, "", url);
    
    $('.prestigeTab').removeClass('open');
    $('#' + tab).addClass('open');

    if ($('#' + tab).length) {
      scrollTo($('#' + tab));
    }
  }
}


/* Exe */

$('.switchCollection').on("click", function() {
  switchCollection($(this));
});


window.addEventListener("DOMContentLoaded", function(event) {
  let params = new URLSearchParams(document.location.search);
  let tab = params.get("tab");
  if(tab) {
    switchCollection($('[aria-controls="' + tab + '"]').first());
  }  
})

/* Others */

function scrollTo($element) {
    $('html, body').animate({
      scrollTop: ($element.offset().top) - 120
    }, 1000);
    return false;
}




